<template>
  <div class="login-warp">
    <div class="login-head">
      <img class="backicon" src="../../assets/imgs/back.png" @click="onBack" />
    </div>
    <img class="banner" src="../../assets/imgs/loginbanner.png" />
    <img class="logowhite" src="../../assets/imgs/logo_white.png" />
    <div class="login-foot">
      <login-apple v-if="system === 'ios'" @success="loadUser()">
        <button class="btn appleloginbtn2" id="sign-in-with-apple-button">
          <img src="../../assets/imgs/icon_applepay.png" alt="" />
          <span>{{ i18n.applelogin }}</span>
        </button>
      </login-apple>
      <login-google v-else @success="loadUser">
        <div id="buttonDiv"></div>
      </login-google>
      <div class="btn otherlogin" @click="goLogin">{{ i18n.otherlogin }}</div>
    </div>
  </div>
</template>

<script>
import { USER_INFO } from "../../apis/user";
import { LoginApple, LoginGoogle } from "../../components/login";
import { mapState } from "vuex";
import loginMixin from "../../mixins/login";
import { getQueryString } from "../../utils/url.js";
export default {
  mixins: [loginMixin],
  components: {
    LoginGoogle,
    LoginApple
  },
  computed: {
    ...mapState(["user", "browser", "system", "qrcode"]),
    i18n() {
      return this.$t("login");
    }
  },
  watch: {
    user(val, oldVal) {
      if (val && !oldVal) {
        this.jumpLogin();
      }
    }
  },
  data() {
    return {
      phone: ""
    };
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    goLogin() {
      this.$router.push("/otherLogin");
    },
    loadUser() {
      this.$loading(true);
      this.$get(
        USER_INFO,
        {},
        res => {
          this.$loading(false);
          if (res.user) {
            this.$store.commit("user", res.user);
            this.$toast(this.i18n.msg_success_login);
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUser();
              })
              .catch(() => {
                this.$store.commit("token", null);
              });
          }
        },
        err => {
          this.$loading(false);
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null);
          });
        }
      );
    },
    jumpLogin() {
      const loginPath = sessionStorage.getItem("_login_path");
      if (loginPath) {
        this.$router.replace({ name: loginPath });
      } else if (this.qrcode) {
        this.$router.push(`/?qrcode=${this.qrcode}`);
      } else {
        this.$router.push({ name: "homeMap" });
      }
    }
  },
  created() {
    const code = getQueryString("code");
    const state = getQueryString("state");
    if (code && state === "STATE") {
      this.loginMpByCode(code, this.loadUser);
    }
  }
};
</script>

<style lang="less" scoped>
.login-warp {
  height: 100vh;
  background: linear-gradient(#00ab46, #1a2229);
  .login-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    .backicon {
      width: 50px;
    }
  }
  .banner {
    width: 90%;
    display: block;
    margin: -13% auto;
  }
  .logowhite {
    width: 15%;
    display: block;
    margin: 0 auto;
  }
  .login-foot {
    width: 90%;
    margin: 40px auto 0;
    .appleloginbtn2 {
      width: 100%;
      border: none;
      background: #fff;
      color: #000;
      margin: 40px 0 0;
      img {
        width: 50px;
        margin-right: 20px;
      }
    }
    .appleloginbtn {
      width: 100%;
      border: none;
      background: #fff;
      color: #000;
      img {
        width: 60px;
        margin-right: 20px;
      }
    }
    .otherlogin {
      width: 100%;
      border: none;
      background: #00ab46;
      color: #fff;
      margin: 40px 0 0;
    }
    &-imgs {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}
</style>
